import { render, staticRenderFns } from "./ThePart3Main.vue?vue&type=template&id=04b8384a&scoped=true"
import script from "./ThePart3Main.vue?vue&type=script&lang=js"
export * from "./ThePart3Main.vue?vue&type=script&lang=js"
import style0 from "./ThePart3Main.vue?vue&type=style&index=0&id=04b8384a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8384a",
  null
  
)

export default component.exports